export const reportRoute = [
  {
    path: '/report/detail/serve',
    component: () => import('./detail/serve')
  },
  // 校医院检验报告详情
  {
    path: '/report/detail/xyy',
    meta: {},
    component: () => import('./detail/xyy')
  },
  // pdf分类
  {
    path: '/report/pdf',
    meta: {title: '查看PDF报告'},
    component: () => import('./pdf')
  },
  // pdf子分类
  {
    path: '/report/pdf/types',
    meta: {},
    component: () => import('./pdf/types')
  }
]



// WEBPACK FOOTER //
// ./src/page/report/route.js